import React from "react";
import {
  LinkItem,
  MainContainer,
  ItemsContainer,
  TitleContainer,
  Title,
  Subject,
  LogoContainer,
  Logo,
} from "./Header.styles";
import {
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaTelegram,
  FaGlobe,
  FaInstagram,
} from "react-icons/fa";
import logo from "assets/images/logo.png";

const Header = () => {
  return (
    <MainContainer>
      <LogoContainer>
        <Logo src={logo} alt="" />
        <ItemsContainer>
          <a
            href="https://www.facebook.com/PeriodicoGiron"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaFacebook color="#fff" size={"1.3em"} />
          </a>

          <a
            href="https://twitter.com/PeriodicoGiron"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaTwitter color="#fff" size={"1.3em"} />
          </a>
          <a
            href="https://www.youtube.com/c/Peri%C3%B3dicoGir%C3%B3n/videos"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaYoutube color="#fff" size={"1.3em"} />
          </a>
          <a
            href="https://www.instagram.com/periodico_giron/"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaInstagram color="#fff" size={"1.3em"} />
          </a>
          <a
            href="https://t.me/+0Mrl6V-DLflmNzhh"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaTelegram color="#fff" size={"1.3em"} />
          </a>
          <a href="http://giron.cu" target={"_blank"} rel="noreferrer">
            <FaGlobe color="#fff" size={"1.3em"} />
          </a>
        </ItemsContainer>
      </LogoContainer>
      <TitleContainer>
        <Title>Carilda</Title>
        <Subject>Cien años de un mito</Subject>
      </TitleContainer>
    </MainContainer>
  );
};

export default Header;
